import { toast } from "react-toastify";

import { clearNumber } from "../../functions";

import { SubscriberModel } from "../../models/subscription";

import { Alert } from "../../../components/ui/Alert";
import { Drawer } from "../../../components/ui/Drawer";
import { PetController } from "../global";
import { useSubscribers } from "../../../store/subscription/useSubscribers";
import { useMerchant } from "../../../store/global/useMerchant";
import { TRANSACTION_PROCESSING_ERRORS, TRANSACTION_PROCESSING_WARNINGS } from "../../../store/subscription/constants";

export default class SubscriberController {
  currentSubscriber = {}
  selectedCycle = null;
  selectedTransaction = null;
  alertIsOpen = Alert.store.getState().actions.isOpen;
  drawerIsOpen = Drawer.store.getState().actions.isOpen;

  constructor() {
    this.name = "subscriptions-subscribers";
    this.tableName = `${this.name}-table`;
    this.subscriptionDetailsDrawerName = `${this.name}-subscription-details-drawer`;

    this.paginationName = `${this.name}-pagination`;
    this.changeCreditCardAlertName = `${this.name}-changeCreditCard-alert`;
    this.pixCodeAlertName = `${this.name}-pixCode-alert`;
    this.changeSubscriptionPlanAlertName = `${this.name}-changePlan-alert`;
    this.cancelSubscriptionAlertName = `${this.name}-cancelSubscription-alert`;
    this.pauseSubscriptionAlertName = `${this.name}-pauseSubscription-alert`;
    this.cycleAppointmentsAlertName = `${this.name}-cycleAppointments-alert`;
    this.cycleTransactionsAlertName = `${this.name}-cycleTransactions-alert`;
    this.cycleRefundAlertName = `${this.name}-cycleRefund-alert`;


    this.MSubscriber = SubscriberModel();
    this.init();
  }

  init = async () => {
    Promise.all([this.findSummary(), this.findSubscribers()]);
  };

  findSummary = async () => {
    await this.MSubscriber.findSummary();
  };

  findSubscribers = async () => {
    await this.MSubscriber.findSubscribers();
  };

  findCycleDetails = async (cycle) => {
    this.selectedCycle = cycle;
    this.MSubscriber.findCycleDetails(cycle.id)
    this.openCycleAppointments()
  };

  findCycleTransactions = async (cycle) => {
    this.selectedCycle = cycle;
    this.MSubscriber.findCycleTransactions(cycle.id)
    this.openCycleTransactions()
  };

  openPixCode = (transaction) => {
    this.selectedTransaction = transaction
    this.alertIsOpen(this.pixCodeAlertName, true);
  };

  closePixCode = () => {
    this.selectedTransaction = null
    this.alertIsOpen(this.pixCodeAlertName, false);
  };

  openCycleAppointments = () => {
    this.alertIsOpen(this.cycleAppointmentsAlertName, true);
  };

  closeCycleAppointments = () => {
    this.alertIsOpen(this.cycleAppointmentsAlertName, false);
  };

  openCycleTransactions = () => {
    this.alertIsOpen(this.cycleTransactionsAlertName, true);
  };

  closeCycleTransactions = () => {
    this.alertIsOpen(this.cycleTransactionsAlertName, false);
  };

  openChangePlan = () => {
    this.alertIsOpen(this.changePlanAlertName, true);
  };

  closeChangePlan = () => {
    this.alertIsOpen(this.changePlanAlertName, false);
  };


  setPage = (page) => {
    this.MSubscriber.setPage(page);
  };

  setSort = (columnKey, sortOrder) => {
    this.MSubscriber.setSortAndFetch(columnKey, sortOrder);
  };

  handleSortColumn = (columnKey) => {
    const { sortBy, sortOrder } = useSubscribers.getState().data.sort;
    const nextOrder = sortBy === columnKey && sortOrder === "asc" ? "desc" : "asc";
    this.setSort(columnKey, nextOrder);
  };

  setFilter = (filterData) => {
    if (filterData.status === '*') filterData.status = ''
    if (filterData.size === '*') filterData.size = ''

    if (filterData.cpf) {
      filterData.cpf = clearNumber(filterData.cpf);
    }

    this.MSubscriber.setFilter(filterData);
  };

  filterSubscribers = async (e) => {
    if (e) e.preventDefault();
    await this.MSubscriber.filterSubscribers();
  };

  showDetails = (subscription) => {
    this.findDetails(subscription)
    this.drawerIsOpen(this.subscriptionDetailsDrawerName, true)
  };

  findDetails = async (subscription) => {
    const details = useSubscribers.getState().data.details

    // Se já temos os detalhes corretos carregados, não precisa recarregar
    if (!!details && details.id === subscription.id) return

    // Limpa os detalhes anteriores antes de carregar novos para evitar cache
    useSubscribers.getState().actions.setDetails(false)

    PetController(subscription.pet.id).startPet()

    await Promise.all([
      this.MSubscriber.findSubscription(subscription.id),
      this.MSubscriber.findAvailablePlans(subscription.pet.id),
    ])
  };

  closeDetailsDrawer = () => {
    // Limpa os detalhes quando o drawer fecha para evitar cache
    useSubscribers.getState().actions.setDetails(false)
    this.drawerIsOpen(this.subscriptionDetailsDrawerName, false)
  };

  changeCreditCardSubscribers = async (subscriber, force = false) => {
    if (subscriber) this.currentSubscriber = subscriber;

    await this.findDetails(this.currentSubscriber)

    if (!force) {
      this.alertIsOpen(this.changeCreditCardAlertName, true);
      return;
    }

    const isSent = await this.MSubscriber.changeCreditCard(this.currentSubscriber.id, this.currentSubscriber.pet.id);

    if (!!isSent) toast.success("Link enviado! Verifique se o cliente tem e-mail cadastrado.", { theme: "colored" });
  };

  cancelSubscribers = async (subscriber, force = false) => {
    if (subscriber) this.currentSubscriber = subscriber;

    await this.findDetails(this.currentSubscriber)

    if (!force) {
      this.alertIsOpen(this.cancelSubscriptionAlertName, true);
      return;
    }

    document.getElementById('cancel-link').innerHTML = ''

    const isSent = await this.MSubscriber.cancelCreditCard(this.currentSubscriber.id);

    document.getElementById('cancel-link').innerHTML = isSent?.data.message || ''

    if (!!isSent) toast.success("Link enviado! Verifique se o cliente tem e-mail cadastrado.", { theme: "colored" });
  };

  pauseSubscribers = async (subscriber, force = false) => {
    if (subscriber) this.currentSubscriber = subscriber;

    await this.findDetails(this.currentSubscriber)

    if (!force) {
      this.alertIsOpen(this.pauseSubscriptionAlertName, true);
      return;
    }

    const isSent = await this.MSubscriber.pausePlan(this.currentSubscriber.id);

    if (!!isSent) toast.success("Link enviado! Verifique se o cliente tem e-mail cadastrado.", { theme: "colored" });
  };

  changeSubscriberPlan = async (subscriber, force = false) => {
    const details = useSubscribers.getState().data.details

    if (subscriber) this.currentSubscriber = subscriber;

    if (!force) {
      this.alertIsOpen(this.changeSubscriptionPlanAlertName, true);
      return;
    }

    const isSent = await this.MSubscriber.changePlan(details.id, this.currentSubscriber);
    if (!!isSent) toast.success("Link enviado! Verifique se o cliente tem e-mail cadastrado.", { theme: "colored" });
  };

  showTransactionProcessingStatusToast = (transaction) => {
    if (!transaction) return

    if (_.includes(TRANSACTION_PROCESSING_WARNINGS, transaction.status.code)) return
    if (_.includes(TRANSACTION_PROCESSING_ERRORS, transaction.status.code)) return toast.error(`Transação recusada. ${transaction.gateway.message}`, { theme: "colored" });

    toast.success("Cobrança realizada com sucesso!", { theme: "colored" })
  }

  tryRecharge = async (subscriber, cycle) => {
    if (subscriber) this.currentSubscriber = subscriber;
    await this.findDetails(this.currentSubscriber)

    const transaction = await this.MSubscriber.tryRecharge(this.currentSubscriber.id, cycle.id);
    this.showTransactionProcessingStatusToast(transaction);
  };

  changeMethodSubscribers = async (subscriber, cycle, method) => {
    if (subscriber) this.currentSubscriber = subscriber;
    await this.findDetails(this.currentSubscriber)

    const transaction = await this.MSubscriber.changePaymentMethod(this.currentSubscriber.id, cycle.id, method);
    if (!transaction) return

    if (method.code === 'pix') this.openPixCode(transaction)
    this.showTransactionProcessingStatusToast(transaction)
  };


  refundTransactions = async (subscriber, force = false) => {
    if (subscriber) this.currentSubscriber = subscriber;

    await this.findDetails(this.currentSubscriber)
    if (!force) {
      this.alertIsOpen(this.cycleRefundAlertName, true);
      return;
    }


    await this.MSubscriber.refundPayment(this.selectedCycle.id);
    this.alertIsOpen(this.cycleRefundAlertName, false);
  };



  priceAdjustment = async (adjustmentData) => {
    try {
      const details = useSubscribers.getState().data.details;
      const merchant = useMerchant.getState().data.merchant;

      if (!details || !details.id) {
        toast.error("Dados da assinatura não encontrados", { theme: "colored" });
        return false;
      }

      // Determinar se é aumento ou redução
      const adjustment = adjustmentData.newPrice > adjustmentData.currentPrice ? "increase" : "decrease";

      // Preparar dados no formato exato que a API espera
      const apiData = {
        storeId: merchant?.id || "",
        subscriptionId: adjustmentData?.subscriptionId || "",
        cpf: details.customer?.cpf || "",
        petName: details.pet?.name || "",
        adjustment: adjustment,
        adjustmentType: "fixed_by_value", // Sempre fixed_by_value conforme solicitado
        adjustmentValue: adjustmentData.newPrice.toString(),
        loja: merchant?.name?.fullName || ""
      };

      console.log('Dados enviados para API de reajuste:', apiData); // Para debug

      const result = await this.MSubscriber.priceAdjustment(apiData);

      if (result?.success) {
        // Sucesso - mostrar mensagem de confirmação
        const successMessage = result.message === "Adicionado"
          ? "Solicitação de reajuste adicionada à fila com sucesso!"
          : result.message || "Solicitação de reajuste enviada com sucesso!";

        toast.success(successMessage, { theme: "colored" });

        // Os dados de priceAdjustment e queueJobs já são atualizados automaticamente pelo modelo
        console.log('Dados da assinatura atualizados automaticamente após reajuste');

        return true;
      } else {
        // Erro - mostrar mensagem específica
        const errorMessage = result?.error || "Erro desconhecido ao processar reajuste";
        toast.error(errorMessage, { theme: "colored" });

        return false;
      }
    } catch (error) {
      console.error('Erro ao processar reajuste:', error);
      toast.error("Erro interno ao processar reajuste", { theme: "colored" });
      return false;
    }
  };

  reportExport = () => {
    this.MSubscriber.export();
  };
}
